/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChatThreadModel,
  KnowledgeBaseReadChatbot,
  KnowledgeChatRequestDto,
  ProblemDetails,
  SmartProblemDetails,
} from '../models/index';
import {
    ChatThreadModelFromJSON,
    ChatThreadModelToJSON,
    KnowledgeBaseReadChatbotFromJSON,
    KnowledgeBaseReadChatbotToJSON,
    KnowledgeChatRequestDtoFromJSON,
    KnowledgeChatRequestDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
} from '../models/index';

export interface ChatDownloadBlobKnowledgebaseBlobGetRequest {
    chatSourceId: string;
}

export interface ChatGetKnowledgeBasesRequest {
    includeHiddenLocations?: boolean;
    enrichWithExtractionModeFromDb?: boolean;
}

export interface ChatPostRequest {
    knowledgeChatRequestDto?: KnowledgeChatRequestDto;
}

export interface ChatStreamPostRequest {
    knowledgeChatRequestDto?: KnowledgeChatRequestDto;
}

/**
 * 
 */
export class ChatApi extends runtime.BaseAPI {

    /**
     */
    async chatDownloadBlobKnowledgebaseBlobGetRaw(requestParameters: ChatDownloadBlobKnowledgebaseBlobGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['chatSourceId'] == null) {
            throw new runtime.RequiredError(
                'chatSourceId',
                'Required parameter "chatSourceId" was null or undefined when calling chatDownloadBlobKnowledgebaseBlobGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Chat/sources/{chatSourceId}/blob`.replace(`{${"chatSourceId"}}`, encodeURIComponent(String(requestParameters['chatSourceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async chatDownloadBlobKnowledgebaseBlobGet(requestParameters: ChatDownloadBlobKnowledgebaseBlobGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.chatDownloadBlobKnowledgebaseBlobGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async chatGetKnowledgeBasesRaw(requestParameters: ChatGetKnowledgeBasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KnowledgeBaseReadChatbot>>> {
        const queryParameters: any = {};

        if (requestParameters['includeHiddenLocations'] != null) {
            queryParameters['includeHiddenLocations'] = requestParameters['includeHiddenLocations'];
        }

        if (requestParameters['enrichWithExtractionModeFromDb'] != null) {
            queryParameters['enrichWithExtractionModeFromDb'] = requestParameters['enrichWithExtractionModeFromDb'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Chat/KnowledgeBases`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KnowledgeBaseReadChatbotFromJSON));
    }

    /**
     */
    async chatGetKnowledgeBases(requestParameters: ChatGetKnowledgeBasesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KnowledgeBaseReadChatbot>> {
        const response = await this.chatGetKnowledgeBasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async chatPostRaw(requestParameters: ChatPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatThreadModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Chat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KnowledgeChatRequestDtoToJSON(requestParameters['knowledgeChatRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatThreadModelFromJSON(jsonValue));
    }

    /**
     */
    async chatPost(requestParameters: ChatPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatThreadModel> {
        const response = await this.chatPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async chatStreamPostRaw(requestParameters: ChatStreamPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatThreadModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Chat/stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KnowledgeChatRequestDtoToJSON(requestParameters['knowledgeChatRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatThreadModelFromJSON(jsonValue));
    }

    /**
     */
    async chatStreamPost(requestParameters: ChatStreamPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatThreadModel> {
        const response = await this.chatStreamPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
